import { FIELD_MAPPINGS } from 'api/CatalogAPI';
import { RestQueryHookResult, useRestQuery } from 'utils/hooks/api/useRestQuery';
import { sortObjectListByKey } from 'utils/arrayHelpers';
import { useError } from 'react-use';
import { HookData, LegacyEndpointQueryResponse } from './types';

export const useLegacyEndpoint = (): Omit<
  RestQueryHookResult<LegacyEndpointQueryResponse>,
  'data'
> & { data: HookData } => {
  const onError = useError();
  const { data = [], ...response } = useRestQuery<LegacyEndpointQueryResponse>(
    FIELD_MAPPINGS,
    {},
    { onError },
  );
  const sortedByNameProperties = sortObjectListByKey(data, 'name');

  return {
    ...response,
    data: sortedByNameProperties,
  };
};
